// extracted by mini-css-extract-plugin
export default {"root":"styles_root__kXl8D","delete-button":"styles_delete-button__Bp2zH","icon":"styles_icon__7qNK1"};